module.exports = __webpack_public_path__ + "img/copy.23c004d0.svg";